module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/opt-b37a82cf0de93f9d8d3d6198342dae44.svg";